import { useRef, useEffect } from 'react';

import { css } from '@compiled/react';

type CheckboxColors = 'light' | 'dark';

export interface CheckboxProps {
	id: string;
	name: string;
	value: string;
	label?: string;
	color?: CheckboxColors;
	accentColor?: string;
	disabled?: boolean;
	testId?: string;
	checked?: boolean;
	indeterminate?: boolean;
	className?: string;
}

const textStyle = css({
	cursor: 'pointer',
	fontSize: '0.875rem',
	fontWeight: 400,
	marginInlineStart: '8px',
});

const containerStyle = css({
	position: 'relative',
	display: 'flex',
	alignItems: 'flex-start',
	padding: '2px 0',
	lineHeight: '1.5',
});

const checkboxStyle = css({
	verticalAlign: 'middle',
	width: '16px',
	height: '16px',
	margin: '4px 0 0',
	'&:hover, &:focus': {
		cursor: 'pointer',
		backgroundColor: '#dfe1e6',
	},
});

export const Checkbox = (props: CheckboxProps) => {
	const {
		id,
		name,
		value,
		label,
		color = 'light',
		accentColor = '#0065ff',
		disabled,
		testId,
		checked,
		indeterminate,
		className,
	} = props;
	const ref = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (ref.current) {
			if (indeterminate) {
				ref.current.indeterminate = indeterminate;
			} else {
				ref.current.checked = checked || false;
			}
		}
	}, [props]);

	return (
		<div className={className} css={containerStyle}>
			<input
				id={id}
				type="checkbox"
				data-testid={testId ? testId : id}
				css={checkboxStyle}
				style={{ accentColor: accentColor }}
				ref={ref}
				name={name}
				value={value}
				disabled={disabled || false}
			/>
			{label && (
				<label
					style={{ color: color == 'dark' ? '#172b4d' : '#5e6c84' }}
					css={textStyle}
					htmlFor={id}
				>
					{label}
				</label>
			)}
		</div>
	);
};
